import dayjs from "dayjs";

type DateRange = {
  start_at: Date,
  end_at: Date
}

type Equipment = {
  id: number,
  color: string,
  size: string,
  datesBlocked: DateRange[]
}

const isEquipmentAvailable = (equipment: Equipment, requestedDateRange: DateRange): boolean => {
  const requestDateRangeStartAt = dayjs(requestedDateRange.start_at);
  const requestDateRangeEndAt = dayjs(requestedDateRange.end_at);

  return !equipment.datesBlocked.some((blockedDateRange) => {
    const blockedStartDate = dayjs(blockedDateRange.start_at);
    const blockedEndDate = dayjs(blockedDateRange.end_at);

    return requestDateRangeStartAt <= blockedStartDate && requestDateRangeEndAt  >= blockedStartDate
      || requestDateRangeStartAt < blockedEndDate && requestDateRangeEndAt  >= blockedEndDate
      || requestDateRangeStartAt >= blockedStartDate && requestDateRangeEndAt  <= blockedEndDate;

  });
}

const getEquipmentAvailable = (equipmentsAvailability: Equipment[], requestedDateRange: DateRange): Equipment | null => {
  return equipmentsAvailability.find((equipment) => isEquipmentAvailable(equipment, requestedDateRange)) ?? null;
}

const maxAvailableDate = (
  equipmentsAvailability: Equipment[],
  periodStartAt : Date,
  maxDuration: number,
  bookingStartTimes: string,
  bookingEndTimes: string,
) => {

  // For end date, we need to substract 1 day if startAt is before endTime
  const numberOfDays = parseInt(maxDuration) - (bookingStartTimes < bookingEndTimes ? 1 : 0)
  const endOfPeriodToCheck = periodStartAt.add(numberOfDays, 'day')
    .hour(bookingEndTimes.split(':')[0])
    .minute(bookingEndTimes.split(':')[1]);

  let dateToCheck = periodStartAt
    .hour(bookingStartTimes.split(':')[0])
    .minute(bookingStartTimes.split(':')[1]);

  // Create a list of equipments available (by default all equipments are available)
  let equipmentsAvailable =  equipmentsAvailability.map((equipmentAvailability) => {
    return equipmentAvailability.id;
  });

  // Loop on each day of the period to check if there is equipments available
  let availableMaxDate;
  while (dateToCheck.isSameOrBefore(endOfPeriodToCheck)) {
    // console.log('dateToCheck', dateToCheck.format('YYYY-MM-DD HH:mm'));

    // Get the list of equipments available at this date
    const equipmentsAvailableAtDate = equipmentsAvailability
      .reduce((equipmentsId, equipmentAvailability) => {
        if (!equipmentAvailability.datesBlocked.find((dateRangeBlocked) => {

          return dayjs(dateToCheck)
            .hour(bookingEndTimes.split(':')[0])
            .minute(bookingEndTimes.split(':')[1])
            .isAfter(dateRangeBlocked.start_at) && dateToCheck.isBefore(dateRangeBlocked.end_at);
        })) {
          equipmentsId.push(equipmentAvailability.id);
        }
        return equipmentsId;
      }, []
    );

    // get intersection of equipmentsAvailable and equipmentsAvailableAtDate
    equipmentsAvailable = equipmentsAvailable.filter(x => equipmentsAvailableAtDate.includes(x));

    if (equipmentsAvailable.length === 0) {
      availableMaxDate = dayjs(dateToCheck)
        .subtract(1, "day")
        .hour(bookingEndTimes.split(':')[0])
        .minute(bookingEndTimes.split(':')[1]);
      break;
    }
    dateToCheck = dateToCheck.add(1, "day");
  }

  if (!availableMaxDate) {
    availableMaxDate = endOfPeriodToCheck;
  }

  return availableMaxDate;
}

// export function getEquipmentAvailable and DateRange type
export {
  getEquipmentAvailable,
  maxAvailableDate,
}
export type {
  DateRange,
  Equipment
}